<template>
    <div>
        <div
            id="content"
            class="content animated slideInRight delay-1s"
        >
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">
                                Exportar Reservas
                                <span
                                    class="required_fields"
                                >
                                    <span class="required">*</span>
                                    Campos obrigatórios
                                </span
                                >
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <form
                                        :action="$store.state.url + 'export/reserves'"
                                        id="export"
                                    >
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label
                                                        for="carDateStart"
                                                    >
                                                        <span class="required">*</span>
                                                        Data de
                                                        Retirada
                                                    </label
                                                    >
                                                    <input
                                                        type="date"
                                                        v-model="reserveVehicles.RetreatDatetime"
                                                        class="form-control"
                                                        name="retreat_date"
                                                        id="retreat_date"
                                                    />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label
                                                        for="carDateEnd"
                                                    >
                                                        <span class="required">*</span>
                                                        Data de
                                                        Devolução
                                                    </label
                                                    >
                                                    <input
                                                        type="date"
                                                        v-model="reserveVehicles.DevolutionDatetime"
                                                        class="form-control"
                                                        name="devolution_date"
                                                        id="devolution_date"
                                                    />
                                                    <input
                                                        type="hidden"
                                                        v-model="this.$store.state.user.id"
                                                        class="form-control"
                                                        name="uid"
                                                        id="uid"
                                                    />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label
                                                        for="carDateEnd"
                                                    >
                                                        <span class="required">*</span>
                                                        Filtrar por
                                                        Status
                                                    </label
                                                    >
                                                    <select
                                                        style="display: inline"
                                                        class="form-control"
                                                        v-model="reserveVehicles.reserve_status"
                                                        name="reserve_status"
                                                        required
                                                    >
                                                        <option
                                                            value="0"
                                                            selected
                                                        >Todos os Status
                                                        </option>
                                                        <option
                                                            v-for="status in reserveStatus"
                                                            :key="status.id"
                                                            :value="status.id"
                                                            :selected="
                                                                    status.id == reserveVehicles.reserve_status
                                                                  "
                                                        >
                                                            {{ status.title }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <hr/>
                                        <div class="block text-right">
                                            <a
                                                @click="checkForm"
                                                class="btn btn-add"
                                            >
                                                Exportar em Excel
                                                <i class="fas fa-file-export ml-2"></i>
                                            </a>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CtkDateTimePicker from "vue-ctk-date-time-picker";

export default {
    data() {
        return {
            reserveVehicles: {
                RetreatDatetime: "",
                DevolutionDatetime: "",
                reserve_status: "0",
            },
            reserveStatus: [],
        };
    },
    methods: {
        checkForm: function () {
            var data_1 = new Date(this.reserveVehicles.RetreatDatetime);
            var data_2 = new Date(this.reserveVehicles.DevolutionDatetime);

            if (
                this.reserveVehicles.RetreatDatetime == "" ||
                this.reserveVehicles.DevolutionDatetime == "" ||
                this.reserveVehicles.reserve_status == ""
            ) {
                swal("Erro", "Os dados do formulário não podem ser vazios", "error");
            } else {
                if (data_1 > data_2) {
                    swal(
                        "Erro",
                        "Data inicial não pode ser maior que data final",
                        "error"
                    );
                } else {
                    document.getElementById("export").submit();
                }
            }
        },
        getReserveStatus: function () {
            let self = this;
            let api = self.$store.state.api + "reserveVehiclesStatus?paginated=false";

            self.$http
                .get(api, {
                    params: {
                        orderByAsc: "id",
                    },
                })
                .then((response) => {
                    self.reserveStatus = response.data.data;
                })
                .catch((error) => {
                });
        },
    },
    mounted: function () {
        const self = this;
        self.getReserveStatus();
    },
    components: {
        CtkDateTimePicker,
    },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Exportation/Reserves.vue